import type { UserEntity } from "../model";

import { EMPTY, SPACE } from "~/shared/str";

type UserNames = Pick<UserEntity.Schema, "firstName" | "lastName">;

function getFullName({ firstName, lastName }: UserNames) {
  return [firstName, lastName].join(SPACE);
}

function splitFullName(fullName: string): UserNames {
  const [firstName = EMPTY, lastName = EMPTY] = fullName.split(SPACE);

  return { firstName, lastName };
}

function getInitials({ firstName, lastName }: UserNames) {
  return [firstName, lastName].map((value) => value.at(0)?.toLocaleUpperCase()).join(EMPTY);
}

export { getFullName, getInitials, splitFullName };
